import { render } from "./DualColumnChart.vue?vue&type=template&id=2f603ee6&scoped=true"
import script from "./DualColumnChart.vue?vue&type=script&lang=js"
export * from "./DualColumnChart.vue?vue&type=script&lang=js"

import "./DualColumnChart.vue?vue&type=style&index=0&id=2f603ee6&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-2f603ee6"]])

export default __exports__